<div class="flex-fill"></div>
<h1 mat-dialog-title></h1>
<div mat-dialog-content>
    <div class="flex flex-column align-center">
        <mat-icon class="icon-xl" [color]="'warn'">warning</mat-icon>
        <h1>Atenção</h1>
        <div class="w-100 center" [innerHTML]="msg"></div>
    </div>
</div>
<div id="div-cancelamento" mat-dialog-actions *ngIf="!cartaAnexa">
  <button mat-raised-button color="primary" type="button" (click)="fileUp.click()">
    Upload Carta de Cancelamento &nbsp;
    <mat-icon>cloud_upload</mat-icon>
  </button>
</div>
<div id="div-cancelamento" mat-dialog-actions *ngIf="cartaAnexa">
  <button mat-raised-button color="primary" type="button" (click)="closeModal()">
   OK
  </button>
</div>
<input #fileUp class="file-upload" type="file" (change)="uploadAtestado($event)"/>
